export default __webpack_public_path__ + "static/city-photo-a518b54f1dd8afcd009f92a3abc97fac.webp";